import { render, staticRenderFns } from "./InboundType.vue?vue&type=template&id=c2b633b4&scoped=true"
import script from "./InboundType.vue?vue&type=script&lang=js"
export * from "./InboundType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b633b4",
  null
  
)

export default component.exports